import { IPurchaseOrder, PurchaseOrder, PurchaseOrderLine } from '$models'
import { PurchaseOrderUi } from '../types'

export function convertPurchaseOrderToPurchaseOrderUi(
  purchaseOrder: IPurchaseOrder
) {
  const purchaseOrderUi: PurchaseOrderUi = {
    ...purchaseOrder,
    lines:
      purchaseOrder?.lines?.map((line) => ({
        ...line,
        lineId: line.id ?? crypto.randomUUID(),
        __reorder__: line.itemName ?? '', // Name displayed when the user starts dragging a row
        isEstimatedCostLoading: false,
      })) ?? [],
  }

  return purchaseOrderUi
}

export function convertPurchaseOrderUiToPurchaseOrder(
  purchaseOrderUi: PurchaseOrderUi
): PurchaseOrder {
  const isCreditRequest = purchaseOrderUi?.creditRequest ?? false

  const lines = purchaseOrderUi?.lines?.map((uiLine, index) => {
    // Destructure and discard UI-only properties
    const {
      lineId: _lineId,
      __reorder__: _reorder,
      isEstimatedCostLoading: _isEstimatedCostLoading,
      ...rest
    } = uiLine

    // Apply negative quantities for credit requests
    const baseQuantity = uiLine?.quantityOrdered ?? 0
    const quantity = isCreditRequest ? -Math.abs(baseQuantity) : baseQuantity

    return new PurchaseOrderLine({
      ...rest,
      quantityOrdered: quantity,
      unitCost: (uiLine?.unitCostOrdered || 0) * (uiLine?.unitRatio || 1),
      lineOrder: index,
    })
  })

  // Calculate totals with proper signs for credit requests
  const subtotal =
    lines?.reduce((acc, line) => {
      const cost = line.unitCost ?? 0
      const qty = line.quantityOrdered ?? 0
      return acc + cost * qty
    }, 0) ?? 0

  const tax =
    lines?.reduce((acc, line) => {
      const cost = line.unitCost ?? 0
      const qty = line.quantityOrdered ?? 0
      const taxRate = line.taxPercent ?? 0
      return acc + cost * qty * taxRate
    }, 0) ?? 0

  return new PurchaseOrder({
    ...purchaseOrderUi,
    lines,
    subtotal: subtotal,
    tax: tax,
    total: subtotal + tax,
  })
}
